// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file Messages/Detailed.proto (package time_tracking.messages.detailed, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_Enumerations_TimeTrackingRole } from "../Enumerations/TimeTrackingRole_pb";
import type { BusinessDto, BusinessLocationDto, IdentityRoleDto, IdentityUserDto, ProjectDto, TrackingDto, TrackingKindDto, UserWorkingTimeModelDto, WorkingTimeModelDto } from "./Basic_pb";
import { file_Messages_Basic } from "./Basic_pb";
import { file_Options_AuthorizationFieldOptions } from "../Options/AuthorizationFieldOptions_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file Messages/Detailed.proto.
 */
export const file_Messages_Detailed: GenFile = /*@__PURE__*/
  fileDesc("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", [file_Enumerations_TimeTrackingRole, file_Messages_Basic, file_Options_AuthorizationFieldOptions]);

/**
 * Represents detailed information about a business that has locations to assign users to.
 *
 * @generated from message time_tracking.messages.detailed.BusinessDetailedDto
 */
export type BusinessDetailedDto = Message<"time_tracking.messages.detailed.BusinessDetailedDto"> & {
  /**
   * Basic information about the business.
   *
   * @generated from field: time_tracking.messages.basic.BusinessDto business = 1;
   */
  business?: BusinessDto | undefined;

  /**
   * The locations of the business.
   *
   * @generated from field: repeated time_tracking.messages.basic.BusinessLocationDto business_locations = 2;
   */
  businessLocations: BusinessLocationDto[];
};

/**
 * Describes the message time_tracking.messages.detailed.BusinessDetailedDto.
 * Use `create(BusinessDetailedDtoSchema)` to create a new message.
 */
export const BusinessDetailedDtoSchema: GenMessage<BusinessDetailedDto> = /*@__PURE__*/
  messageDesc(file_Messages_Detailed, 0);

/**
 * Represents detailed information about the location of a business to which users can be assigned to.
 *
 * @generated from message time_tracking.messages.detailed.BusinessLocationDetailedDto
 */
export type BusinessLocationDetailedDto = Message<"time_tracking.messages.detailed.BusinessLocationDetailedDto"> & {
  /**
   * Basic information about the business location.
   *
   * @generated from field: time_tracking.messages.basic.BusinessLocationDto business_location = 1;
   */
  businessLocation?: BusinessLocationDto | undefined;

  /**
   * The business the location belongs to
   *
   * @generated from field: time_tracking.messages.basic.BusinessDto business = 2;
   */
  business?: BusinessDto | undefined;
};

/**
 * Describes the message time_tracking.messages.detailed.BusinessLocationDetailedDto.
 * Use `create(BusinessLocationDetailedDtoSchema)` to create a new message.
 */
export const BusinessLocationDetailedDtoSchema: GenMessage<BusinessLocationDetailedDto> = /*@__PURE__*/
  messageDesc(file_Messages_Detailed, 1);

/**
 * Represents detailed information about a role a user of the application can possess.
 *
 * @generated from message time_tracking.messages.detailed.IdentityRoleDetailedDto
 */
export type IdentityRoleDetailedDto = Message<"time_tracking.messages.detailed.IdentityRoleDetailedDto"> & {
  /**
   * Basic information about the role.
   *
   * @generated from field: time_tracking.messages.basic.IdentityRoleDto role = 1;
   */
  role?: IdentityRoleDto | undefined;
};

/**
 * Describes the message time_tracking.messages.detailed.IdentityRoleDetailedDto.
 * Use `create(IdentityRoleDetailedDtoSchema)` to create a new message.
 */
export const IdentityRoleDetailedDtoSchema: GenMessage<IdentityRoleDetailedDto> = /*@__PURE__*/
  messageDesc(file_Messages_Detailed, 2);

/**
 * Represents detailed information about a user that can log in to the application.
 *
 * @generated from message time_tracking.messages.detailed.IdentityUserDetailedDto
 */
export type IdentityUserDetailedDto = Message<"time_tracking.messages.detailed.IdentityUserDetailedDto"> & {
  /**
   * Basic information about the user.
   *
   * @generated from field: time_tracking.messages.basic.IdentityUserDto user = 1;
   */
  user?: IdentityUserDto | undefined;

  /**
   * The business locations the user has been added to.
   *
   * @generated from field: repeated time_tracking.messages.basic.BusinessLocationDto business_locations = 2;
   */
  businessLocations: BusinessLocationDto[];

  /**
   * The projects the user has been added to.
   *
   * @generated from field: repeated time_tracking.messages.basic.ProjectDto projects = 3;
   */
  projects: ProjectDto[];

  /**
   * The working time models that have been assigned to the user.
   *
   * @generated from field: repeated time_tracking.messages.basic.UserWorkingTimeModelDto user_working_time_models = 4;
   */
  userWorkingTimeModels: UserWorkingTimeModelDto[];
};

/**
 * Describes the message time_tracking.messages.detailed.IdentityUserDetailedDto.
 * Use `create(IdentityUserDetailedDtoSchema)` to create a new message.
 */
export const IdentityUserDetailedDtoSchema: GenMessage<IdentityUserDetailedDto> = /*@__PURE__*/
  messageDesc(file_Messages_Detailed, 3);

/**
 * Represents detailed information about a project where users can add trackings to.
 *
 * @generated from message time_tracking.messages.detailed.ProjectDetailedDto
 */
export type ProjectDetailedDto = Message<"time_tracking.messages.detailed.ProjectDetailedDto"> & {
  /**
   * Basic information about the project.
   *
   * @generated from field: time_tracking.messages.basic.ProjectDto project = 1;
   */
  project?: ProjectDto | undefined;

  /**
   * The users that have been added to the project.
   *
   * @generated from field: repeated time_tracking.messages.basic.IdentityUserDto users = 2;
   */
  users: IdentityUserDto[];
};

/**
 * Describes the message time_tracking.messages.detailed.ProjectDetailedDto.
 * Use `create(ProjectDetailedDtoSchema)` to create a new message.
 */
export const ProjectDetailedDtoSchema: GenMessage<ProjectDetailedDto> = /*@__PURE__*/
  messageDesc(file_Messages_Detailed, 4);

/**
 * Represents detailed information about a tracking of a particular user.
 *
 * @generated from message time_tracking.messages.detailed.TrackingDetailedDto
 */
export type TrackingDetailedDto = Message<"time_tracking.messages.detailed.TrackingDetailedDto"> & {
  /**
   * Basic information about the tracking.
   *
   * @generated from field: time_tracking.messages.basic.TrackingDto tracking = 1;
   */
  tracking?: TrackingDto | undefined;

  /**
   * The user the tracking belongs to.
   *
   * @generated from field: time_tracking.messages.basic.IdentityUserDto user = 2;
   */
  user?: IdentityUserDto | undefined;

  /**
   * The optional project the tracking has been assigned to.
   *
   * @generated from field: time_tracking.messages.basic.ProjectDto project = 3;
   */
  project?: ProjectDto | undefined;
};

/**
 * Describes the message time_tracking.messages.detailed.TrackingDetailedDto.
 * Use `create(TrackingDetailedDtoSchema)` to create a new message.
 */
export const TrackingDetailedDtoSchema: GenMessage<TrackingDetailedDto> = /*@__PURE__*/
  messageDesc(file_Messages_Detailed, 5);

/**
 * Represents detailed information about the kind of a tracking (billable, etc.).
 *
 * @generated from message time_tracking.messages.detailed.TrackingKindDetailedDto
 */
export type TrackingKindDetailedDto = Message<"time_tracking.messages.detailed.TrackingKindDetailedDto"> & {
  /**
   * Basic information about the tracking kind.
   *
   * @generated from field: time_tracking.messages.basic.TrackingKindDto tracking_kind = 1;
   */
  trackingKind?: TrackingKindDto | undefined;
};

/**
 * Describes the message time_tracking.messages.detailed.TrackingKindDetailedDto.
 * Use `create(TrackingKindDetailedDtoSchema)` to create a new message.
 */
export const TrackingKindDetailedDtoSchema: GenMessage<TrackingKindDetailedDto> = /*@__PURE__*/
  messageDesc(file_Messages_Detailed, 6);

/**
 * Represents detailed information about a user and working time model association.
 *
 * @generated from message time_tracking.messages.detailed.UserWorkingTimeModelDetailedDto
 */
export type UserWorkingTimeModelDetailedDto = Message<"time_tracking.messages.detailed.UserWorkingTimeModelDetailedDto"> & {
  /**
   * Basic information about the user and working time model association.
   *
   * @generated from field: time_tracking.messages.basic.UserWorkingTimeModelDto user_working_time_model = 1;
   */
  userWorkingTimeModel?: UserWorkingTimeModelDto | undefined;

  /**
   * Information about the user in the association.
   *
   * @generated from field: time_tracking.messages.basic.IdentityUserDto user = 2;
   */
  user?: IdentityUserDto | undefined;
};

/**
 * Describes the message time_tracking.messages.detailed.UserWorkingTimeModelDetailedDto.
 * Use `create(UserWorkingTimeModelDetailedDtoSchema)` to create a new message.
 */
export const UserWorkingTimeModelDetailedDtoSchema: GenMessage<UserWorkingTimeModelDetailedDto> = /*@__PURE__*/
  messageDesc(file_Messages_Detailed, 7);

/**
 * Represents detailed information about a working time model.
 *
 * @generated from message time_tracking.messages.detailed.WorkingTimeModelDetailedDto
 */
export type WorkingTimeModelDetailedDto = Message<"time_tracking.messages.detailed.WorkingTimeModelDetailedDto"> & {
  /**
   * Basic information about the working time model.
   *
   * @generated from field: time_tracking.messages.basic.WorkingTimeModelDto working_time_model = 1;
   */
  workingTimeModel?: WorkingTimeModelDto | undefined;

  /**
   * Information about the users that have been associated with the working time model.
   *
   * @generated from field: repeated time_tracking.messages.basic.UserWorkingTimeModelDto user_working_time_models = 2;
   */
  userWorkingTimeModels: UserWorkingTimeModelDto[];

  /**
   * Information about user and working time model associations that had to be terminated because
   * of updated assignability ranges of the working time model.
   *
   * @generated from field: repeated time_tracking.messages.basic.UserWorkingTimeModelDto terminated_user_working_time_models = 3;
   */
  terminatedUserWorkingTimeModels: UserWorkingTimeModelDto[];
};

/**
 * Describes the message time_tracking.messages.detailed.WorkingTimeModelDetailedDto.
 * Use `create(WorkingTimeModelDetailedDtoSchema)` to create a new message.
 */
export const WorkingTimeModelDetailedDtoSchema: GenMessage<WorkingTimeModelDetailedDto> = /*@__PURE__*/
  messageDesc(file_Messages_Detailed, 8);

